import React from 'react';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { Heading3 } from '../../ui/Typography/Heading';
import { EyecandyNotAuthorized } from '../../ui/Icons';
import {
  OnboardingContent,
  OnboardingContentGroup,
  OnboardingContentGroupText,
  OnboardingContentTitle,
  OnboardingHeaderGroup,
  OnboardingStepWrapper
} from '../../ui/Layout/OnboardingLayout';

export const OnboardingStepLocked = () => {
  return (
    <>
      <OnboardingNavbar logoutLabel="Abmelden" />
      <OnboardingContent className="step-locked">
        <OnboardingStepWrapper className="step-locked">
          <OnboardingHeaderGroup className="step-locked">
            <EyecandyNotAuthorized />
            <OnboardingContentTitle>
              <Heading3>Die Einrichtung läuft noch</Heading3>
            </OnboardingContentTitle>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="step-locked">
            <OnboardingContentGroupText>
              Der Administrator richtet das Versicherungsportal derzeit ein. Sobald die Einführung abgeschlossen ist,
              wird der Zugriff auf das Portal automatisch für alle Nutzer freigeschaltet und Sie können mit dem
              Schadenmanagement beginnen.
            </OnboardingContentGroupText>
          </OnboardingContentGroup>
        </OnboardingStepWrapper>
      </OnboardingContent>
    </>
  );
};
